import React, { useState } from 'react';
import { CheckCheck } from 'lucide-react';
import { formatTime } from '@/utils/commsFormat';

// "Seen 10:42" for 1:1, "Seen by N" (tap for names) in channels.
export const SeenMarker = ({ seen, members = [] }) => {
  const [open, setOpen] = useState(false);
  if (!seen) return null;

  if (seen.readers) {
    const names = seen.readers.map((id) => members.find((m) => m.id === id)?.name || 'Unknown');
    return (
      <div className="seen-marker" data-testid="seen-marker">
        <button type="button" className="seen-toggle" onClick={() => setOpen((o) => !o)} data-testid="seen-by-toggle">
          <CheckCheck size={12} /> Seen by {names.length}
        </button>
        {open && (
          <div className="seen-list" data-testid="seen-by-list">
            {names.map((n, i) => <span key={`${n}-${i}`}>{n}</span>)}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="seen-marker" data-testid="seen-marker">
      <CheckCheck size={12} /> Seen{seen.read_at ? ` ${formatTime(seen.read_at)}` : ''}
    </div>
  );
};
